import * as yup from "yup";

export const BaseSchema = {
  client_codes: yup.string().label("This field").required(),
      primary_lang: yup
        .object()
        .label("This field")
        .required()
        .typeError("This field is a required"),
      CurrencyId: yup
        .object()
        .label("This field")
        .required()
        .typeError("This field is a required"),
      ClientType: yup
        .object()
        .label("This field")
        .required()
        .typeError("This field is a required"),
      logo_img: yup
        .mixed()
        .optional()
        .label("This field")
        .test(
          "fileTypeValidation",
          "Only jpeg/jpg/png file types are allowed",
          (file) => {
            // console.log("gl-validate:", file)
            const fileTypeList = ["image/jpeg", "image/jpg", "image/png"];
            //if u want to allow only certain file types only
  
            return !file[0] || (!!file[0] && fileTypeList.includes(file[0].type));
          },
        )
        .test(
          "fileSizeValidation",
          "The file size should be less than 1MB",
          (file) => {
            // console.log("gl-validate:", file)
            //if u want to allow only certain file sizes
            return !file[0] || (!!file[0] && file[0].size <= 1 * 1024 * 1024);
          },
    ),
};